import { render, staticRenderFns } from "./ExportDataCenter.vue?vue&type=template&id=6b747292&scoped=true"
import script from "./ExportDataCenter.vue?vue&type=script&lang=js"
export * from "./ExportDataCenter.vue?vue&type=script&lang=js"
import style0 from "./ExportDataCenter.vue?vue&type=style&index=0&id=6b747292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b747292",
  null
  
)

export default component.exports